export const channelSavedFailed = {
  title: '無法操作，請聯繫線上顧問',
};
